@if (onboarding.offerVisible()) {
  <section
    class="onboarding-welcome"
    data-testid="onboarding-welcome"
    role="region"
    aria-labelledby="onboarding-welcome-title">
    <div class="onboarding-welcome__icon">
      <lucide-icon
        name="compass"
        [size]="18"
        aria-hidden="true" />
    </div>
    <div class="onboarding-welcome__body">
      <h2
        id="onboarding-welcome-title"
        class="onboarding-welcome__title">
        Boas-vindas ao GextorPro!
      </h2>
      <p class="onboarding-welcome__description">
        Vamos mostrar onde ficam as principais funções para você começar.
      </p>
      <div class="onboarding-welcome__actions">
        <button
          pButton
          type="button"
          class="p-button-sm"
          data-testid="onboarding-welcome-accept"
          (click)="onboarding.accept()">
          <span>Conhecer o GextorPro</span>
          <lucide-icon
            name="arrow-right"
            [size]="14"
            aria-hidden="true" />
        </button>
        <button
          pButton
          type="button"
          class="p-button-outlined p-button-sm"
          data-testid="onboarding-welcome-decline"
          (click)="onboarding.decline()">
          Agora não
        </button>
      </div>
    </div>
  </section>
}
